import { DOCUMENT } from '@angular/common';
import { inject, InjectionToken } from '@angular/core';

export const BROWSER_WINDOW = new InjectionToken<Window | null>('BrowserWindow', {
  providedIn: 'root',
  factory: () => inject(DOCUMENT).defaultView,
});

export const LOCAL_STORAGE = new InjectionToken<Storage | null>('LocalStorage', {
  providedIn: 'root',
  factory: () => inject(BROWSER_WINDOW)?.localStorage ?? null,
});

export const SESSION_STORAGE = new InjectionToken<Storage | null>('SessionStorage', {
  providedIn: 'root',
  factory: () => inject(BROWSER_WINDOW)?.sessionStorage ?? null,
});

export const BROWSER_SCREEN = new InjectionToken<Screen | null>('BrowserScreen', {
  providedIn: 'root',
  factory: () => inject(BROWSER_WINDOW)?.screen ?? null,
});
